import { render, staticRenderFns } from "./ImportarModulosModal.vue?vue&type=template&id=5beb8d5f"
import script from "./ImportarModulosModal.vue?vue&type=script&lang=js"
export * from "./ImportarModulosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports